var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C4.86 1.5 1.5 4.86 1.5 9c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5ZM5.513 13.875A5.956 5.956 0 0 1 9 12.75c1.305 0 2.505.42 3.488 1.125A5.956 5.956 0 0 1 9 15a5.956 5.956 0 0 1-3.487-1.125Zm8.092-1.035a7.46 7.46 0 0 0-9.21 0A5.967 5.967 0 0 1 3 9c0-3.315 2.685-6 6-6s6 2.685 6 6a5.967 5.967 0 0 1-1.395 3.84Z",
    fill: "#6D6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5a2.628 2.628 0 0 0-2.625 2.625A2.628 2.628 0 0 0 9 9.75a2.628 2.628 0 0 0 2.625-2.625A2.628 2.628 0 0 0 9 4.5Zm0 3.75a1.123 1.123 0 0 1-1.125-1.125C7.875 6.503 8.377 6 9 6s1.125.503 1.125 1.125S9.623 8.25 9 8.25Z",
    fill: "#6D6D6D"
  })));
};
export default SvgAccount;